/** MUI dark palette — spec: pure #000 surfaces, zinc greys, #3b82f6 primary */
export const colorPaletteDark = {
  mode: 'dark',
  primary: { main: '#3b82f6' },
  error: { main: '#ef4444' },
  success: { main: '#22c55e' },
  warning: { main: '#ea580c' },
  info: { main: '#3b82f6' },
  background: {
    default: '#000000',
    paper: '#000000',
  },
  text: {
    primary: 'rgba(255, 255, 255, 0.8)',
    secondary: 'rgba(255, 255, 255, 0.6)',
    tertiary: 'rgba(255, 255, 255, 0.4)',
    labelTag: 'rgba(255, 255, 255, 0.4)',
    disabled: 'rgba(255, 255, 255, 0.3)',
  },
  divider: '#27272a',
  action: {
    active: 'rgba(255, 255, 255, 0.8)',
    hover: 'rgba(244, 244, 245, 0.06)',
    selected: 'rgba(244, 244, 245, 0.1)',
    disabled: '#52525b',
    disabledBackground: '#27272a',
    focus: 'rgba(59, 130, 246, 0.2)',
  },
}
